<template>
    <header id="bp-header" class="container-fluid fixed-top" :class="this.$route.name == 'Listing Detail'? 'propertyDetail': ''">
        <div class="row h-100">
            <div class="col d-flex align-items-center justify-content-start h-100"></div>
            <div class="col d-flex align-items-center justify-content-center h-100">
                <router-link to="/">
                    <img :src="defaultLogo" class="img-fluid-height" />
                </router-link>
            </div>
            <div class="col d-flex align-items-center justify-content-end h-100"></div>
        </div>
    </header>

    <div id="main-nav" class="">
            <button id="navBtn" class="hamburger hamburger--collapse" type="button" @click="navigationFunc()">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
            <div id="navItems" class="d-none">
                <div class="col-12 col-lg-8 h-100">
                    <div class="row h-100 justify-content-center">
                        <div class="col-12 col-lg-3 d-flex flex-column align-items-start justify-content-center h-100 nav-item">
                            <router-link to="/" @click="closeNav()"></router-link>
                            <h5 class="copy-heading-sub">01</h5>
                            <h2 class="heading-main">Home</h2>
                            <!-- <p>If you are interested in placing your property on the market, or would like to chat about any of our listings, reach out to us today.</p> -->
                        </div>
                        <div class="col-12 col-lg-3 d-flex d-md-flex flex-column align-items-start justify-content-center h-100 nav-item">
                            <router-link to="/sold" @click="closeNav()"></router-link>
                            <h5 class="copy-heading-sub">02</h5>
                            <h2 class="heading-main">Sold</h2>
                            <!-- <p>Check out our recent sold properties and if you would like to chat, reach out to us today.</p> -->
                        </div>
                        <div class="col-12 col-lg-3 d-flex d-md-flex flex-column align-items-start justify-content-center h-100 nav-item">
                            <router-link to="/reviews" @click="closeNav()"></router-link>
                            <h5 class="copy-heading-sub">03</h5>
                            <h2 class="heading-main">Reviews</h2>
                            <!-- <p>A selection of kind words and testimonials from our purchasers and vendors.</p> -->
                        </div>
                         <div class="col-12 col-lg-3 d-flex d-md-flex flex-column align-items-start justify-content-center h-100 nav-item">
                            <router-link to="/connections" @click="closeNav()"></router-link>
                            <h5 class="copy-heading-sub">04</h5>
                            <h2 class="heading-main">Connections</h2>
                            <!-- <p>A selection of kind words and testimonials from our purchasers and vendors.</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-none d-lg-flex position-fixed top-0 end-0 bp-socials">
            <ul class="list-group list-group d-flex align-items-end justify-content-center bp-list-group">

                 <li
                    class="list-group-item"
                    v-for="social in socials"
                >
                    <a 
                        :href="social.url" 
                        target="_blank"
                    >
                        <i 
                            :class="['fa-brands fa-' + social.icon ]"
                        >
                        </i>
                    </a>
                </li>

            </ul>
        </div>

</template>

<script>
    // global vars
    let windowOffset


    // Assets
    import logoPos from '../../assets/bellingen_property_pos.png';
    import logoRev from '../../assets/bellingen_property_rev.png';

    export default({
        data() {
            return {
                defaultLogo: logoRev,
                socials: [
                    {
                        media:  "facebook",
                        icon:   "facebook-f",
                        url:    "https://www.facebook.com/BellingenProperty"
                    },
                    {
                        media:  "youtube",
                        icon:   "youtube",
                        url:    "https://www.youtube.com/channel/UCpzBcT9VCqCeCjOuM5-fgIQ"
                    },
                    {
                        media:  "instagram",
                        icon:   "instagram",
                        url:    "https://www.instagram.com/bellingenproperty/"
                    }
                ]
            }
        },
        methods: {
            navigationFunc() {

                const nav_Btn = document.getElementById( 'navBtn' );
                const nav_parent = document.getElementById( "main-nav" );
                const nav_items = document.getElementById( "navItems" );

                nav_Btn.classList.toggle( 'is-active' );

                // open navigation
                nav_parent.classList.toggle( 'is-active' );
                setTimeout( function() {
                    nav_items.classList.toggle( 'd-none' );
                }, 100 );

            },
            closeNav() {
                const nav_Btn = document.getElementById( 'navBtn' );
                nav_Btn.click();
            },
            header() {

                window.addEventListener( 'scroll', function() {
                    const headerElem = document.getElementById( "bp-header" );
                    const logoHeaderImage = document.querySelector( '#bp-header a > img' );
                    windowOffset = window.pageYOffset;

                    if( windowOffset > 100 ){
                        headerElem.classList.add( 'alt-header' );
                        logoHeaderImage.setAttribute( 'src', logoPos);
                    }else{
                        headerElem.classList.remove( 'alt-header' );
                        logoHeaderImage.setAttribute( 'src', logoRev);
                    }

                });
            },
            logo() {
                const logoHeaderImage = document.querySelector( '#bp-header .img-fluid' );
                const logoFooterImage = document.querySelector( '#bp-footer .img-fluid' );

                logoHeaderImage.setAttribute( 'src', logoRev);
                //logoFooterImage.setAttribute( 'src', logoRev);

            }
        },
        mounted() {
            this.header();
            //this.logo();
        }
    });
</script>

<style lang="scss" scoped>
    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    #bp-header {
        @include animation( all, .35s, ease-in-out );
        background-color:transparent;
        height:200px;
        overflow:hidden;
        z-index:5000;
        &.alt-header {
            @include panelShadows( 0, 5px, 15px, #00253220 );
            background-color:$white;
            height:90px;
        }
        &.propertyDetail {
            background-color:$black;
        }
        a {
            align-items:center;
            display:flex;
            justify-content:center;
            height:100%;
            width:auto;
            img {
                cursor:pointer;
            }
        }
    }


    // navigation
    #main-nav {
        @include animation( all, .35s, ease-in-out );
        background-color:$black;
        height:100vh;
        position:fixed;
        right:0;
        min-width:90px;
        top:0;
        z-index:10000;
        #navBtn {
            -webkit-appearance: unset;
            background-color:$color_main;
            border:0;
            cursor:pointer;
            height:90px;
            position:absolute;
            right:0;
            top:0;
            width:90px;
            z-index:15000;
        &.hamburger {
                .hamburger-box {
                    .hamburger-inner {
                        background-color:$white;
                        &:before, &:after {
                            background-color:$white;
                        }
                    }
                }
                &:hover {
                    opacity:1;
                }
            }
        }
        #navItems {
            height:100%;
            justify-content: center;
            opacity:0;
            .nav-item {
                @include animation( all, .2s, ease-out );
                border-right:1px solid $text;
                cursor:pointer;
                padding-left:2em;
                padding-right:3em;
                position:relative;
                &:before {
                    @include animation( all, .3s, ease-out );
                    background-color:$color_main;
                    content:'';
                    height:0%;
                    left:0;
                    opacity:.8;
                    position:absolute;
                    top:0;
                    width:100%;
                    z-index:-1;
                }
                .copy-heading-sub {
                    @include animation( all, .2s, ease-out );
                    color:$color_main;
                }
                .heading-main {
                    color:$white;
                    font-size:3.5em;
                }
                p{
                    color:lighten( $text, 10% );
                }
                &:last-child {
                    border-right:unset;
                }
                &:hover {
                    &:before {
                        height:100%;
                    }
                    .copy-heading-sub {
                        color:$white;
                        opacity:.7;
                    }
                    p{
                        color:$color_base;
                        opacity:.7;
                    }
                }
                a {
                    background-color:transparent;
                    bottom:0;
                    left:0;
                    position:absolute;
                    right:0;
                    top:0;
                    z-index:+1;
                }
            }
        }
        &.is-active {
            background-color:$black;
            height:100vh;
            left:auto;
            position:fixed;
            width:100%;
            z-index: 6000;
            #navItems {
                display:flex;
                opacity:1;
            }
        }
    }

    // socials
    .bp-socials {
        margin-top:100px;
        z-index:+15000;
        .list-group-item {
            align-items:center;
            background-color:transparent;
            border:0;
            border-radius:0;
            cursor:pointer;
            display:flex;
            height:90px;
            justify-content:center;
            padding:0;
            width:90px;
            a {
                @include animation( all, .3s, ease-in-out );
                color:$color_main;
                font-size:2.5em;
            }
            &:hover {
                a {
                    color:$white;
                }
            }
        }
    }

@media screen and (max-width:$mobile){
    #bp-header {
        height:100px;
        &.alt-header {
            + #main-nav {
                #navBtn {
                    .hamburger-box {
                        .hamburger-inner {
                            background-color:$black;
                            &:before, &:after {
                                background-color:$black;
                            }
                        }
                    }
                }
            }
        }
    }
    
    #main-nav {
        background-color:transparent;
        min-width:60px;
        #navBtn {
            align-items:center;
            background-color:transparent;
            display:flex;
            height:60px;
            justify-content:center;
            padding:0;
            width:60px;
        }
        #navItems {
            > div {
                > div {
                    display:flex;
                    flex-direction:column;
                    .nav-item {
                        border:0;
                        height:calc( 100% / 4 ) !important;
                        justify-content:center !important;
                        padding:2em 3em;
                        .heading-main {
                            font-size:3em;
                        }
                        p {
                            font-size:85%;
                        }
                        &:not(:last-child) {
                            border-bottom:1px solid $text;
                        }
                        &:before {
                            height:100%;
                            opacity:0;
                            width:100%;
                        }
                        &:hover {
                            &:before {
                                opacity:1;
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>